import { createApp } from "vue";
import { AppRegistryHelper } from "./helpers/app-registry.helper";

import App from "./App.vue";

const app = createApp(App);

const appRegistryHelper = new AppRegistryHelper(app);
if (import.meta.env.VITE_ENABLE_SENTRY === "true") {
  appRegistryHelper.initializeSentry();
} else
  console.info(
    "Skipping Sentry initialization for environment:\n",
    import.meta.env.VITE_ENVIRONMENT
  );
appRegistryHelper.injectAppDependencies();

appRegistryHelper.app.mount("#app");
